import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

var IconCategoryValueGroup = function IconCategoryValueGroup(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$inline = _ref.inline,
      inline = _ref$inline === void 0 ? false : _ref$inline;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('icon-category-value-group', {
      'inline-group': inline
    }, className)
  }, children);
};

IconCategoryValueGroup.displayName = "IconCategoryValueGroup";
IconCategoryValueGroup.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
  className: PropTypes.object,
  inline: PropTypes.bool
};
export { IconCategoryValueGroup };